import { lazy } from 'react';

export default [
  {
    title: 'Profile Page',
    component: lazy(() => import('./Profile')),
    url: '/profile',
    requirePermission: true,
    roles: ['Client'],
  },
];
